import { c as _c } from "react/compiler-runtime";
import { ForwardedRef } from 'react';
import { Accordion } from '@navikt/ds-react';
import { OrganisasjonMedState } from '../Virksomhetsvelger/useTastaturNavigasjon';
import styles from './EnheterMedUnderenheter.module.css';
import { Hovedenhet } from './Hovedenhet';
import { Underenhet } from './Underenhet';
export const EnhetMedUnderenheter = t0 => {
  const $ = _c(13);
  const {
    organisasjon,
    onUnderenhetValgt,
    onHovedenhetClick,
    onFocus,
    enhetRef,
    tvingTabbable,
    kunHovedenheter
  } = t0;
  let t1;
  if ($[0] !== organisasjon.underenheter) {
    t1 = organisasjon.underenheter.some(_temp);
    $[0] = organisasjon.underenheter;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const underenhetErValgt = t1;
  const headerId = `hovedenhet-${organisasjon.orgnr}`;
  const contentId = `underenheter-${organisasjon.orgnr}`;
  let t2;
  if ($[2] !== contentId || $[3] !== enhetRef || $[4] !== headerId || $[5] !== kunHovedenheter || $[6] !== onFocus || $[7] !== onHovedenhetClick || $[8] !== onUnderenhetValgt || $[9] !== organisasjon || $[10] !== tvingTabbable || $[11] !== underenhetErValgt) {
    t2 = <><div className={styles.enhet} role="group">{kunHovedenheter ? <Underenhet key={organisasjon.orgnr} underenhet={organisasjon} ref={organisasjon.fokusert ? enhetRef : null} onClick={() => onUnderenhetValgt(organisasjon)} onFocus={() => {
          if (!organisasjon.fokusert) {
            onFocus(organisasjon);
          }
        }} tabbable={organisasjon.ekspandert} /> : <Accordion.Item open={organisasjon.ekspandert}><Accordion.Header tabIndex={tvingTabbable || underenhetErValgt ? 0 : -1} ref={organisasjon.fokusert ? enhetRef : null} id={headerId} aria-controls={contentId} onClick={() => {
            onHovedenhetClick(organisasjon);
          }} onFocus={() => {
            if (!organisasjon.fokusert) {
              onFocus(organisasjon);
            }
          }} style={{
            backgroundColor: organisasjon.ekspandert ? "var(--ax-bg-accent-soft" : "transparent"
          }}><Hovedenhet hovedenhet={organisasjon} antallUnderenheter={organisasjon.underenheter.length} /></Accordion.Header><div id={contentId} role="region" aria-labelledby={headerId} aria-hidden={!organisasjon.ekspandert} data-expanded={organisasjon.ekspandert} className={styles.underenheterWrapper}><div className={styles.underenheter}>{organisasjon.underenheter.map(underenhet => <Underenhet key={underenhet.orgnr} underenhet={underenhet} ref={underenhet.fokusert ? enhetRef : null} onClick={() => onUnderenhetValgt(underenhet)} onFocus={() => {
                if (!underenhet.fokusert) {
                  onFocus(underenhet);
                }
              }} tabbable={organisasjon.ekspandert} />)}</div></div></Accordion.Item>}</div></>;
    $[2] = contentId;
    $[3] = enhetRef;
    $[4] = headerId;
    $[5] = kunHovedenheter;
    $[6] = onFocus;
    $[7] = onHovedenhetClick;
    $[8] = onUnderenhetValgt;
    $[9] = organisasjon;
    $[10] = tvingTabbable;
    $[11] = underenhetErValgt;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
function _temp(t0) {
  const {
    valgt
  } = t0;
  return valgt;
}